import * as React from 'react';

import gql from 'graphql-tag';
import { compact, filter, sortBy } from 'lodash';
import { compose } from 'recompose';

import withFragments from 'bundles/graphql/components/withFragments';
import { getDisplayName, shouldDisplayOnPartnerPage } from 'bundles/graphql/utils/InstructorsV1';
import Instructor, { instructorFragment } from 'bundles/partners-graphql/components/Instructor';
import type { PartnerPageQuery_PartnersV1Resource_shortName_partners_instructors as InstructorsGql } from 'bundles/partners-graphql/components/__generated__/PartnerPageQuery';

type PropsFromCaller = {
  instructors: InstructorsGql | null;
};

export const Instructors = ({ instructors }: PropsFromCaller) => {
  if (!instructors) {
    return null;
  }

  const instructorsList = compact(instructors?.elements);

  const sortedInstructors = () => {
    const instructorsToDisplay = filter(compact(instructorsList), (instructor) =>
      shouldDisplayOnPartnerPage(instructor)
    );
    return sortBy(instructorsToDisplay, (instructor) => getDisplayName(instructor));
  };

  return (
    <div className="bt3-row rc-Instructors">
      <div className="bt3-col-md-12">
        {sortedInstructors().map((instructor) => (
          <Instructor key={instructor.id} instructor={instructor} />
        ))}
      </div>
    </div>
  );
};

export const instructorsFragment = gql`
  fragment InstructorsFragment on InstructorsV1Connection {
    elements {
      id
      ...InstructorFragment
      ...InstructorsV1_getDisplayName
      ...InstructorsV1_shouldDisplayOnPartnerPage
    }
  }
  ${instructorFragment}
  ${getDisplayName.fragment}
  ${shouldDisplayOnPartnerPage.fragment}
`;

export default compose<PropsFromCaller, PropsFromCaller>(
  withFragments({
    instructorsFragment,
  })
)(Instructors);
